enum RegistrationState {
    PENDING_VERIFICATION = "PENDING_VERIFICATION",
    PENDING_COMPANY_REGISTRATION = "PENDING_COMPANY_REGISTRATION",
    PENDING_PARITY_PROPERTY = "PENDING_PARITY_PROPERTY",
    PENDING_PROPERTIES = "PENDING_PROPERTIES",
    PENDING_HOTELS_ENRICH = "PENDING_HOTELS_ENRICH",
    PENDING_HOTELS_RANKING = "PENDING_HOTELS_RANKING",
    PENDING_UPDATE_MARKET_STATE = "PENDING_UPDATE_MARKET_STATE",
    PENDING_SUBSCRIPTION_PLAN = "PENDING_SUBSCRIPTION_PLAN",
    PENDING_INVITATION_ACCEPTANCE = "PENDING_INVITATION_ACCEPTANCE",
    COMPLETED = "COMPLETED"
}

export default RegistrationState;